/**
 * TWA Platform utilities
 * Shared functions for determining platform capabilities based on Canvas domain
 */

export { TWA_DOMAINS, BASIC_DOMAINS, isTwaHosted }

/**
 * Canvas domains that TWA owns/controls
 * These platforms support full user creation and enrollment management
 *
 * IMPORTANT: Must match CANVAS_TWA_DOMAINS in api/config/initializers/canvas.rb
 */
// Basic = TWA's self-hosted Canvas; Premium = Instructure-hosted Canvas
const BASIC_DOMAINS = [
  'learn.dev.truewayasl.com',
  'learn.truewayasl.com'
]

const TWA_DOMAINS = [
  ...BASIC_DOMAINS,
  'asl.instructure.com',
  'asl.beta.instructure.com',
  'asl.test.instructure.com'
]

/**
 * Check if a course is hosted on TWA's Canvas infrastructure
 * TWA-hosted courses support Direct Join, user creation, and auto re-enrollment
 *
 * @param {Object} course - Course object with canvas_domain property
 * @returns {boolean} True if hosted on TWA Canvas
 */
function isTwaHosted(course) {
  return TWA_DOMAINS.includes(course.canvas_domain)
}
